<template>
	<input class="input" v-model="valueC" @input="update"/>
</template>

<script>
export default {
	props: {
		value: {type: [String, Number], required: true}
	},
	data() {
		return {
			valueC: this.value
		}
	},
	methods: {
		update() {
			this.$emit("input", this.valueC);
		}
	}
};
</script>

<style lang="scss" scoped>
.input {
	outline: none;
	appearance: none;
	font-size: 14px;
	border: 1px solid #CCCCCC;
	height: 44px;
	padding: 0 16px;
	width: 100%;

	@include placeholder {
		color: transparentize($black1, 0.5);
	}
}
</style>
